/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import logo from "../../Images/logo-sm.png"
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux';
import { handleLoginUser } from '../../Redux/AuthSlice';
import { LOGIN_URL } from '../Common/API';
import toast from 'react-hot-toast';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';

function FloatCard({ style, delay, icon, label }) {
  return (
    <div
      className="absolute z-10 rounded-xl border border-blue-200 bg-white/90 px-3 py-2 text-xs font-medium text-blue-700 shadow-sm backdrop-blur-sm whitespace-nowrap"
      style={{ ...style, animation: `floatUp 4s ease-in-out ${delay} infinite` }}
    >
      <span className="mr-1">{icon}</span>
      {label}
    </div>
  );
}

function OfficeScene() {
  return (
    <div
      className="relative flex h-full w-full items-center justify-center overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 50%, #f0f9ff 100%)' }}
    >
      <div className="absolute -left-20 -top-20 h-72 w-72 rounded-full bg-blue-300/20 blur-3xl" />
      <div className="absolute -bottom-12 -right-10 h-48 w-48 rounded-full bg-sky-300/20 blur-3xl" />
      <FloatCard style={{ top: '20%', left: '4%' }} delay="0s" icon="📊" label="Revenue +24%" />
      <FloatCard style={{ top: '34%', right: '3%' }} delay="1.3s" icon="👥" label="1,248 Contacts" />
      <FloatCard style={{ top: '62%', left: '3%' }} delay="2.5s" icon="✅" label="12 Tasks done" />
      <FloatCard style={{ bottom: '18%', right: '4%' }} delay="0.7s" icon="📈" label="Pipeline $84K" />

      {[
        { top: '18%', left: '48%', delay: '0s' },
        { top: '45%', left: '20%', delay: '0.6s' },
        { top: '68%', left: '67%', delay: '1.1s' },
        { top: '30%', left: '74%', delay: '1.7s' },
      ].map((dot, index) => (
        <span
          key={index}
          className="absolute h-2 w-2 rounded-full bg-blue-500"
          style={{ top: dot.top, left: dot.left, animation: `pulseDot 2.2s ease-in-out ${dot.delay} infinite` }}
        />
      ))}

      <div
        style={{
          width: 280,
          height: 280,
          transformStyle: 'preserve-3d',
          animation: 'rotateScene 18s linear infinite',
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            width: 200,
            height: 200,
            background: '#dbeafe',
            border: '1px solid #bfdbfe',
            transform: 'rotateX(90deg) translateZ(-52px)',
            left: 40,
            top: 40,
            backgroundImage: 'linear-gradient(#bfdbfe 1px,transparent 1px),linear-gradient(90deg,#bfdbfe 1px,transparent 1px)',
            backgroundSize: '34px 34px',
          }}
        />

        <div
          style={{
            position: 'absolute',
            width: 105,
            height: 8,
            background: '#c4a97d',
            borderRadius: 2,
            transform: 'translateX(-52px) translateY(-16px) translateZ(22px)',
            left: '50%',
            top: '56%',
          }}
        >
          <div style={{ position: 'absolute', width: 6, height: 36, background: '#a8895a', bottom: 8, left: 8 }} />
          <div style={{ position: 'absolute', width: 6, height: 36, background: '#a8895a', bottom: 8, right: 8 }} />
        </div>

        <div
          style={{
            position: 'absolute',
            width: 36,
            height: 24,
            background: '#e2e8f0',
            border: '1px solid #cbd5e1',
            borderRadius: '3px 3px 0 0',
            transform: 'translateX(-18px) translateY(-8px) translateZ(14px) rotateX(-10deg)',
            left: '50%',
            top: '56%',
          }}
        />
        <div
          style={{
            position: 'absolute',
            width: 42,
            height: 8,
            background: '#cbd5e1',
            border: '1px solid #94a3b8',
            borderRadius: 3,
            transform: 'translateX(-21px) translateY(24px) translateZ(12px)',
            left: '50%',
            top: '56%',
          }}
        />

        <div
          style={{
            position: 'absolute',
            width: 10,
            height: 12,
            background: '#e2e8f0',
            border: '1px solid #cbd5e1',
            transform: 'translateX(-5px) translateY(-56px) translateZ(26px)',
            left: '50%',
            top: '56%',
          }}
        />
        <div
          style={{
            position: 'absolute',
            width: 52,
            height: 36,
            background: '#1d4ed8',
            border: '2px solid #e2e8f0',
            borderRadius: 3,
            transform: 'translateX(-26px) translateY(-92px) translateZ(26px)',
            left: '50%',
            top: '56%',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 5,
              left: 5,
              right: 5,
              height: 4,
              background: '#93c5fd',
              borderRadius: 2,
              animation: 'screenBlink 3s ease-in-out infinite',
            }}
          />
          <div style={{ position: 'absolute', top: 13, left: 5, right: 14, height: 3, background: '#60a5fa', borderRadius: 1, boxShadow: '0 6px 0 #3b82f6' }} />
          <div style={{ position: 'absolute', bottom: 4, left: 5, display: 'flex', alignItems: 'flex-end', gap: 2 }}>
            {[8, 14, 10, 18, 12].map((height, index) => (
              <div key={index} style={{ width: 5, height, background: index % 2 === 1 ? '#60a5fa' : '#93c5fd', borderRadius: '1px 1px 0 0' }} />
            ))}
          </div>
        </div>

        <div
          style={{
            position: 'absolute',
            width: 46,
            height: 56,
            background: '#c4a97d',
            border: '1px solid #a8895a',
            transform: 'translateX(66px) translateY(-46px) translateZ(12px)',
            left: '50%',
            top: '50%',
          }}
        >
          {[
            { left: 4, height: 24, color: '#ef4444' },
            { left: 12, height: 20, color: '#f59e0b' },
            { left: 20, height: 26, color: '#3b82f6' },
            { left: 28, height: 18, color: '#22c55e' },
            { left: 36, height: 22, color: '#a855f7' },
          ].map((book, index) => (
            <div key={index} style={{ position: 'absolute', bottom: 4, left: book.left, width: 6, height: book.height, background: book.color, borderRadius: 1 }} />
          ))}
        </div>

        <div
          style={{
            position: 'absolute',
            width: 18,
            height: 14,
            background: '#ef4444',
            borderRadius: '2px 2px 4px 4px',
            transform: 'translateX(-82px) translateY(-24px) translateZ(24px)',
            left: '50%',
            top: '56%',
          }}
        />
        <div
          style={{
            position: 'absolute',
            width: 28,
            height: 28,
            background: '#22c55e',
            borderRadius: '50% 50% 40% 40%',
            transform: 'translateX(-87px) translateY(-52px) translateZ(24px)',
            left: '50%',
            top: '56%',
            animation: 'sway 3.5s ease-in-out infinite',
          }}
        />
      </div>

      <style>{`
        @keyframes rotateScene {
          from { transform: rotateX(20deg) rotateY(0deg); }
          to { transform: rotateX(20deg) rotateY(360deg); }
        }
        @keyframes floatUp {
          0%, 100% { transform: translateY(0); opacity: .85; }
          50% { transform: translateY(-8px); opacity: 1; }
        }
        @keyframes pulseDot {
          0%, 100% { transform: scale(1); opacity: .4; }
          50% { transform: scale(2.2); opacity: .9; }
        }
        @keyframes screenBlink {
          0%, 100% { opacity: 1; }
          50% { opacity: .45; }
        }
        @keyframes sway {
          0%, 100% { transform: translateX(-87px) translateY(-52px) translateZ(24px) rotate(-3deg); }
          50% { transform: translateX(-87px) translateY(-52px) translateZ(24px) rotate(3deg); }
        }
      `}</style>
    </div>
  );
}

const Login = () => {
  const navigate = useNavigate()
  const [remember, setRemember] = useState(false)
  const { loading } = useSelector((state) => state.root.auth);
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setError("");

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${LOGIN_URL}?Email=${data?.email}&Password=${data?.password}&SystemTimeZone=${new Date()
        .toLocaleDateString(undefined, {
          day: "2-digit",
          timeZoneName: "long",
        })
        .substring(4)}`,
      headers: {
      },
    };
    const response = dispatch(handleLoginUser({ config }));
    if (response) {
      response
        .then((res) => {
          const response = res?.payload;
          if (response.status === 200) {
            window.localStorage.setItem("timer", JSON.stringify(18_00));
            if (response?.isSuperAdmin) {
              localStorage.setItem("role_access", "SUPER_ADMIN");
            } else {
              localStorage.setItem("role_access", "USER")
            }
          } else {
            toast.remove();
            setError(response?.message || response?.title || "Unable to sign in.");
            toast.error(response?.message || response?.title);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <div className="min-h-screen w-screen overflow-hidden bg-slate-100">
      <div className="flex h-screen w-screen overflow-hidden">
        <div className="hidden md:flex h-full flex-[1.15]">
          <OfficeScene />
        </div>

        <div className="flex h-full flex-1 flex-col justify-center bg-white px-6 py-10 sm:px-10 border-l border-slate-100">
          <div className="mx-auto w-full max-w-md">
            <div className="mb-8 flex flex-col items-center text-center">
              <div className="mb-5 flex h-12 w-12 items-center justify-center">
                <img src={logo} alt="logo" className="h-12 w-12 object-contain" />
              </div>
              <h3 className="font-semibold text-black text-xl mb-1">Let's Get Started Disploy CRM</h3>
              <p className="mt-1 text-sm text-slate-500">Sign in to continue to Disploy CRM.</p>
            </div>

            {error && (
              <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-600">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              <div>
                <label className="mb-1.5 block text-xs font-medium text-slate-600">Email</label>
                <input
                  type="email"
                  placeholder="you@company.com"
                  className={`w-full rounded-lg border bg-slate-50 px-4 py-2.5 text-sm text-slate-900 outline-none transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 ${errors.email ? 'border-red-500 focus:border-red-500 focus:ring-red-100' : 'border-slate-200'}`}
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Enter a valid email address",
                    },
                  })}
                />
                {errors.email && <p className="mt-1 text-xs font-semibold text-red-500">{errors.email.message}</p>}
              </div>

              <div>
                <label className="mb-1.5 block text-xs font-medium text-slate-600">Password</label>
                <div className="relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="••••••••"
                    className={`w-full rounded-lg border bg-slate-50 py-2.5 pl-4 pr-14 text-sm text-slate-900 outline-none transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 ${errors.password ? 'border-red-500 focus:border-red-500 focus:ring-red-100' : 'border-slate-200'}`}
                    {...register("password", {
                      required: "Password is required",
                    })}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((current) => !current)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 rounded p-1 text-slate-400 transition-colors hover:text-slate-600"
                  >
                    {showPassword ? <BsFillEyeFill size={16} /> : <BsFillEyeSlashFill size={16} />}
                  </button>
                </div>
                {errors.password && <p className="mt-1 text-xs font-semibold text-red-500">{errors.password.message}</p>}
              </div>

              <div className="flex items-center justify-end text-sm">
                {/* <label className="flex cursor-pointer select-none items-center gap-2">
                  <input
                    type="checkbox"
                    onChange={(e) => setRemember(e.target.checked)}
                    checked={remember}
                    className="h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500"
                  />
                  <span className="text-xs font-semibold tracking-wide text-slate-600">Remember me</span>
                </label> */}

                <button
                  type="button"
                  onClick={() => navigate('/Forgot-password')}
                  className="text-xs font-semibold text-blue-600 hover:underline"
                >
                  Forgot password?
                </button>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="mt-2 flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-5 py-3 text-sm font-medium tracking-wide text-white transition-all duration-200 hover:bg-blue-700 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
              >
                {loading ? (
                  <>
                    <svg className="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                    </svg>
                    Signing in...
                  </>
                ) : 'Sign in'}
              </button>
            </form>

            <div className="my-5 flex items-center gap-3">
              <div className="h-px flex-1 bg-slate-200" />
              <span className="text-xs text-slate-400">or</span>
              <div className="h-px flex-1 bg-slate-200" />
            </div>

            {/* <button className="flex w-full items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white py-2.5 text-sm text-slate-700 transition-all duration-200 hover:border-slate-300 hover:bg-slate-50 active:scale-[0.98]">
              <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <rect x="3" y="11" width="18" height="11" rx="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
              Continue with SSO
            </button> */}

            <p className="mt-6 text-center text-xs font-semibold uppercase tracking-wide text-slate-400">
              Don't have an account?{' '}
              <button type="button" onClick={() => navigate('/register')} className="text-blue-600 hover:underline">
                Sign up
              </button>
            </p>


          </div>
        </div>
      </div>

      <style>{`
        @keyframes greenPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: .3; }
        }
      `}</style>
    </div>
  );
}

export default Login;